window.UserAutoComplete = new function()
{
    this.vars = {
      timer: 0,
      autocomplete_interval: false,
      token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        $('html').click(function(e) {
            if(!$(e.target).is('input') && $(e.target).attr('id') != 'users') {
                jQuery('.user-autocomplete-v1').empty();
            }
        });

        jQuery('body').on('click', '.add-user-autocomplete', function(event) {
            event.preventDefault();
            var el = jQuery(this).closest('.user-autocomplete-wrapper');

            jQuery(el).find('.user-autocomplete-v1').empty();
            jQuery(el).find('input#users').val('');

            var name = jQuery(this).text();
            var id   = jQuery(this).data('id');
            if(!UserAutoComplete.userAlreadyAdded(el, id)) {
                jQuery(el).find('.user-autocomplete-v1').empty();
                jQuery(el).find('input#users').val('');
                jQuery(el).find('.user-list').append('<li><a href="javascript:;" class="remove-user"><i class="fas fa-times-circle"></i><span class="user-name">' + name + '</span></a><input type="hidden" name="users[]" value="' + id + '" /></li>');

                var user_tag_input = jQuery(el).closest('.user-autocomplete-wrapper').find('input[name="media_user_tags[]"]');
                UserAutoComplete.setImageUserTags(user_tag_input);
            }

            jQuery(el).find('input#users').focus();
        });

        jQuery('body').on('click', '.remove-user', function(event) {
            event.preventDefault();
            var user_tag_input = jQuery(this).closest('.user-autocomplete-wrapper').find('input[name="media_user_tags[]"]');
            jQuery(this).parent().remove();

            UserAutoComplete.setImageUserTags(user_tag_input);
        });

        jQuery('body').on('click', 'input#users', function(event) {
            UserAutoComplete.triggerAutocompleteAction(this, event);
        });

        jQuery('body').on('focus', 'input#users', function(event) {
            UserAutoComplete.triggerAutocompleteAction(this, event);
        });

        jQuery('body').on('keyup', 'input#users', function(event) {
            if(event.which == 27) {
                //Escape key
                return;
            }

            UserAutoComplete.triggerAutocompleteAction(this, event);
        });

        /**
         * Trigger the autocomplete action on input click/focus/keyup
         *
         * @param obj el - input being focused on
         * @param obj event - the event in question (click/focus/keyup)
         */
        this.triggerAutocompleteAction = function(el, event) {
            var user_autocomplete_wrapper = jQuery(el).closest('.user-autocomplete-wrapper');
            var that                      = el;

            UserAutoComplete.vars.timer = 0;

            if(event.which != 38) { // up
                if(UserAutoComplete.vars.autocomplete_interval) {
                    clearInterval(UserAutoComplete.vars.autocomplete_interval);
                    UserAutoComplete.vars.autocomplete_interval = false;
                }

                jQuery(user_autocomplete_wrapper).find('.user-autocomplete-v1').empty();

                if(!UserAutoComplete.vars.autocomplete_interval) {
                    UserAutoComplete.vars.autocomplete_interval = setInterval(function() { 
                        UserAutoComplete.vars.timer++;

                        //Throttle AJAX request to 1 interval pass of no typing from the user (300 miliseconds)
                        if(UserAutoComplete.vars.timer >= 1) {
                            clearInterval(UserAutoComplete.vars.autocomplete_interval);
                            UserAutoComplete.vars.autocomplete_interval = false;
                            UserAutoComplete.vars.timer                 = 0;

                            var val = jQuery(that).val();
                            if(val.length >= 2) {
                                UserAutoComplete.openUserAutocomplete(user_autocomplete_wrapper, val);
                            }
                        }
                    }, 300);
                }
            }
        };

        /**
         * Open user autocomplete
         * 
         * @param obj el - the instance of the user autocomplete (if more than one on a single page)
         * @param string search_term
         */
        this.openUserAutocomplete = function(el, search_term) {
            var action = jQuery(el).closest('form').attr('action');
            var restricted_list;

            if (action.includes('/conversations/conversation/save')) {
                restricted_list = true;
            }

            $.ajax({
                url: '/users/autocomplete-v1',
                type: 'POST',
                data: {
                    search_term: search_term.toLowerCase(),
                    restricted_list: restricted_list,
                    _token: UserAutoComplete.vars.token
                },
                showloader: true,
                success: function(response) { 
                    var users = JSON.parse(response);
                    for(user in users) {
                        jQuery(el).find('.user-autocomplete-v1').append('<li><a href="javascript:;" class="add-user-autocomplete" data-id="' + users[user].id + '">@' + users[user].username + '</a></li>');
                    }
                }
            });
        };

        /**
         * Checks if user was already added to the list so it cannot be added twice
         * 
         * @param obj el - the instance of the user autocomplete (if more than one on a single page)
         * @param int id
         * @return bool added
         */
        this.userAlreadyAdded = function(el, id) {
            var added = false;

            jQuery(el).find('.user-list li').each(function(index, el2) {
                if(jQuery(el2).find('input').val() == id) {
                    added = true;
                }
            });

            return added;
        };

        /**
         * Reset the comma separated user IDs based on what users are tagged
         *
         * @param obj user_tag_input - the input to change the value of
         */
        this.setImageUserTags = function(user_tag_input) {
            var ids = [];

            jQuery(user_tag_input).closest('.user-autocomplete-wrapper').find('input[name="users[]"]').each(function(index, el) {
                ids.push(jQuery(el).val());
            });

            ids = ids.join(",");
            jQuery(user_tag_input).val(ids);
        };
    };
}

jQuery(document).ready(function($) {
    UserAutoComplete.init();
});
